import { Button, Card, Form, Input,Typography } from 'antd';
import React, { useState,useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import api from '../../../../../apis';
import { showMessageModal,showSuccessMessageModal } from '../../../../utils';
import { useNavigate } from 'react-router-dom'; 
const { Title, Text } = Typography;
const recaptcha_auth ="6Ldbeo4rAAAAAB_ck0MgBUiECJCDodyvSaceURl0"

const Index = ({}) => {
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        const id = 'recaptcha-enterprise';
        if (document.getElementById(id)) {
          setLoaded(true);
          return;
        }
    
        const script = document.createElement('script');
        script.id = id;
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptcha_auth}`;
        script.async = true;
        script.defer = true;
        script.onload = () => setLoaded(true);
        document.head.appendChild(script);
    
        return () => {
    
        };
      }, []);


    const handleCaptchaChange = (token) => {
      console.log("Captcha token:", token);
      setCaptchaToken(token);
      // Send this token to backend for verification
    };

    const onFinish = (values) => {
        // if (!captchaToken) {
        //   showMessageModal('Please complete the CAPTCHA.');
        //   return;
        // }
    
        // Combine form values and captcha token here
        console.log('Form values:', values);
        // console.log('CAPTCHA Token:', captchaToken);
        handlePostForgetUserID(values);
 
    };

    const handlePostForgetUserID = async (values) => {
  
       try {

            window.grecaptcha.enterprise.ready(async () => {
                const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                action: 'PASSWORD_RESET',
                });

                const result = await api.forgetUserID(values,token);
                //  console.log('result:', result);
                
                if(result){
                    if(result.status == 0){
                        showSuccessMessageModal(result.message);
                        form.resetFields();
    
                        navigate('/login');
                    }else{
                        showMessageModal(result.message);
                    }
                }
            
        
            })
           
    
      } catch (error) {
        console.error('Error during forgetUserID request:', error);
        showMessageModal(error)
        // Handle error, e.g., show error message to user
        // message.error("Failed to submit request. Please try again.");
      }
    }
    
  

    return (
        <> 
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#f5f5f5', // Optional for better visibility
                    padding: 24,
                }}
            >
            <Card  style={{ maxWidth: 600, margin: '0 auto', padding: 24, borderRadius: 12,boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                
                <div className=' register-form'>
                    <Title level={3}>	
                    Recover Your User ID</Title>
                        <Text>	
Please complete the following data associated with your UOB Kay Hian account.

Contact your authorized Dealer's Representative if you have forgotten your registered email.</Text>
                        <br />
            
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        style={{ marginTop: 24 }}
                    >
                
                        <Form.Item
                            label="Email Address registered with us"
                            name="email"
                            rules={[
                                { required: true, message: 'Please enter your email address' },
                                { type: 'email', message: 'Please enter a valid email address' },
                              ]}
                            >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="NRIC / Passport / Business Reg. No."
                            name="identity"
                            rules={[
                                { required: true, message: 'Please enter your identification number' },
                                {
                                pattern: /^[0-9a-zA-Z]+$/,
                                message: 'Please enter numbers only without dash or space',
                                },
                            ]}
                            extra={<Text type="secondary">(Please enter numbers only without dash or space)</Text>}
                        >
                            <Input 
                                onChange={(e) => {
                                    const cleaned = e.target.value.replace(/[-\s]/g, '');
                                    form.setFieldsValue({ identity: cleaned });
                                }}
                            />
                        </Form.Item>

                        {/* <div style={{ marginBottom: 16 }} className='d-flex justify-content-center align-items-center pt-3 pb-3'>
                            <ReCAPTCHA
                                sitekey={recaptcha_auth} // Replace with your actual key
                                onChange={handleCaptchaChange}
                                className="recaptcha-container" 
                            />
                        </div> */}

                        <div style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                Submit
                            </Button>
                        </div>
                    </Form>

                    {/* <Text type="secondary" style={{ display: 'block', marginTop: 16, textAlign: 'center' }}>
                        This page requires CAPTCHA Validation to proceed. Click <a href="#">here</a> to check if your browser is supported.
                    </Text> */}
    
                </div>
            </Card>
            </div>
        </>
    );
};

export default Index;
